// extracted by mini-css-extract-plugin
export var addressWrapper = "location-module--address-wrapper--bDrJg";
export var locationAddress = "location-module--location-address--UfKke";
export var locationMap = "location-module--location-map--wp8CM";
export var locationWrapper = "location-module--location-wrapper--8hTni";